import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';
import { RequireStaff } from '@features/cms/components/RequireStaff.tsx';

const RemindersPage = lazyWithRetry(() => import('../pages/RemindersPage.tsx'));
const AutomaticRemindersPage = lazyWithRetry(() => import('../pages/AutomaticRemindersPage.tsx'));

const RemindersRoute = () => (
  <RequireStaff render={() => <RemindersPage />} />
);

const AutomaticRemindersRoute = () => (
  <RequireStaff render={() => <AutomaticRemindersPage />} />
);

const remindersNode: ComponentPage = {
  component: RemindersRoute,
  handle: { breadcrumb: 'reminders' },
};

const remindersRoutes: ComponentOrMapping = {
  erp: {
    communication: {
      reminders: remindersNode,
      'automatic-reminders': {
        component: AutomaticRemindersRoute,
        handle: { breadcrumb: 'automatic-reminders' },
      },
    },
  },
};

export default remindersRoutes;
